import { selector, selectorFamily } from "recoil";
import { FolderTree } from "../../api-client-nswag/custompermission-client";
import { folderTreeState } from "../store/folderTree.store";
import { entitySnapshotFolderTreeSelector } from "./legalEntities.selectors";
import { areArraysEqual, makeUsersMap } from "../../util/Utils";
import { legalEntitiesState } from "../store/legalEntities.store";

export const folderTreeSelector = selector<FolderTree>({
  key: "folderTree/selector",
  get: ({ get }) => get(folderTreeState),
})

export const isEntityFolderTreeUsersDirtySelector = selectorFamily<boolean, number>({
  key: "legalEntities/isEntityFolderTreeUsersDirty",
  get: (clientId: number) => ({ get }) => {
    if (clientId === 0) return false
    const snapshotTree = get(entitySnapshotFolderTreeSelector(clientId));
    const currentTree = get(folderTreeSelector);

    const snapMap = makeUsersMap(snapshotTree);
    const currMap = makeUsersMap(currentTree);

    let dirty = false;

    currMap.forEach((currentUsers, folderId) => {
      if (dirty) return;
      const originalUsers = snapMap.get(folderId) ?? [];
      if (!areArraysEqual(currentUsers, originalUsers)) {
        dirty = true;
      }
    });
    if (dirty) return true;

    snapMap.forEach((_users, folderId) => {
      if (dirty) return;
      if (!currMap.has(folderId)) {
        dirty = true;
      }
    });
    return dirty;
  },
});

export const isSiteFolderPermissionDirtySelector = selector<boolean>({
  key: "legalEntities/isSiteFolderPermissionDirty",
  get: ({ get }) => {
    const { folderPermission } = get(legalEntitiesState);
    const folderPermissionSelector = get(folderTreeSelector);
    if (!Array.isArray(folderPermissionSelector) || !Array.isArray(folderPermission)) {
      return false;
    }

    const makeUsersMap = (tree: FolderTree) => {
      const map = new Map<number, string[]>();
      const stack = [...tree];
      while (stack.length) {
        const node = stack.pop()!;
        map.set(node.folderId, node.users ?? []);
        if (Array.isArray(node.children) && node.children.length) {
          stack.push(...node.children);
        }
      }
      return map;
    };

    const snapMap = makeUsersMap(folderPermission);
    const currMap = makeUsersMap(folderPermissionSelector);

    let dirty = false;

    currMap.forEach((users, folderId) => {
      const originalUsers = snapMap.get(folderId) ?? [];
      if (!areArraysEqual(users, originalUsers)) {
        dirty = true;
      }
    });

    snapMap.forEach((_users, folderId) => {
      if (!currMap.has(folderId)) {
        dirty = true;
      }
    });
    
    return dirty;
  },
});



